"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const FormSection_1 = require("../../../utils/FormSection");
const LimitTypeSelector_1 = require("./LimitTypeSelector");
const LimitList_1 = require("./LimitList");
const LimitSelector_1 = require("./LimitSelector");
const FrequencyLimits = ({ device, wizardSection }) => (React.createElement(FormSection_1.default, { device: device, style: { paddingTop: 24 } },
    React.createElement(src_1.Text, { text: "Frequency Limits", size: "h1", textStyle: { marginBottom: 8 } }),
    React.createElement(LimitTypeSelector_1.default, { device: device }),
    React.createElement(LimitList_1.default, { device: device }),
    React.createElement(LimitSelector_1.default, { device: device, type: "add" })));
exports.default = FrequencyLimits;
